import { IElement } from '../Element';
import { ICoding, isCodingEqual, isCodingEqualByCode } from '../Coding';
export const isCodeableConceptEqual = (
  a?: ICodeableConcept,
  b?: ICodeableConcept,
) => {
  if (a === b) return true;
  if (!a || !b) return false;
  if (a.coding && b.coding) {
    return a.coding.every(aCoding => {
      if (!b.coding) return false;
      return b.coding.some(bCoding => isCodingEqual(aCoding, bCoding));
    });
  } else return a.text === b.text;
};

export const codeableConceptEqualHasCode = (
  a: ICodeableConcept | undefined,
  code: string | undefined,
) => {
  if (!a || !code) return false;
  if (a.coding) {
    return a.coding.some(aCoding => isCodingEqualByCode(aCoding, code));
  } else return false;
};
export interface ICodeableConcept extends IElement {
  coding?: ICoding[];
  text?: string;
}
